//css,js読み込み
import "./scss/style.scss";
import "./scss/page.scss";

//page sp image scroll読み込み,option
import 'scroll-hint/css/scroll-hint.css';
import ScrollHint from 'scroll-hint';
new ScrollHint('.js-scrollable', {
  scrollHintIconAppendClass: 'scroll-hint-icon-white',
  i18n: {
    scrollable: document.documentElement.lang === 'en' ? "Scroll" : "スクロールできます"
  }
});

//////
//強制リロードトップ
//////



window.addEventListener('beforeunload', () => {
  window.scrollTo(0,0);
});
window.scrollTo(0, 0);

// 1) ブラウザの自動スクロール復元を無効化（対応ブラウザのみ）
if ('scrollRestoration' in history) {
  try {
    history.scrollRestoration = 'manual';
  } catch (e) {
    // 一部環境で例外が出る可能性があるため安全対策
  }
}

// 共通でスクロールをトップにする関数
function forceScrollTop() {
  // 2つ呼んでおく（同期 + requestAnimationFrame）
  window.scrollTo(0, 0);
  // 少し遅延して確実に消す
  requestAnimationFrame(() => window.scrollTo(0, 0));
  setTimeout(() => {
    try { window.scrollTo(0, 0); } catch (e) {}
  }, 50);
}

// pageshow は bfcache 復元時にも呼ばれる（iOS Safari 対策）
window.addEventListener('pageshow', (event) => {
  // event.persisted が true のときは bfcache 復元
  // 通常のページ表示でも確実にトップにしたければ常に呼んでOK
  forceScrollTop();
});

// load も念のため
window.addEventListener('load', () => {
  forceScrollTop();
});

// beforeunload/unload で離脱時にトップへ（効かない場合もあるが念のため）
window.addEventListener('beforeunload', () => {
  try { window.scrollTo(0, 0); } catch (e) {}
});


//////
//高さ調整js
//////
let windowW = window.innerWidth;
let windowH = window.innerHeight;

function changeHeight() {
  const newWindowW = window.innerWidth;
  const newWindowH = window.innerHeight;

  // 幅か高さが変わった場合のみ更新
  if (newWindowW !== windowW || newWindowH !== windowH) {
    document.documentElement.style.setProperty('--vh', `${newWindowH * 0.01}px`);
    windowW = newWindowW;
    windowH = newWindowH;
  }
}



changeHeight();

let timer = null;
window.addEventListener('resize', () => {
  if (timer !== null) clearTimeout(timer);

  timer = setTimeout(() => {
    changeHeight();
  }, 100);
});





//関数雨使用したい場合
//import { disableScroll,enableScroll,lockScroll } from "./js/menu.js";




import "./js/menu.js"; // メニュー



if (document.querySelector("header.hTop")) {
  
  Promise.all([
    import("./js/top.js"),
    import("./js/canvas.js"),
  ]).then(([topModule, canvasModule]) => {
    console.log("top.js and canvas.js loaded for hTop page!");

  });
}



if (document.querySelector("header.page")) {
  import("./js/page.js").then(() => {
    console.log("page.js loaded for hTop page!");
    
  });
}































import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

document.addEventListener("DOMContentLoaded", () => {
  new Swiper('.swiper-container', {
    loop: true,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    on: {
      slideChange: function () {
        // アクティブスライドを取得
        const activeSlide = this.slides[this.activeIndex];
        if (!activeSlide) return;

        // スライドの id を取得
        const targetId = activeSlide.getAttribute('id');
        if (!targetId) return;

        // komaImg の中から .select をリセット
        /*
        const komaImg = document.querySelector('.komaImg');
        komaImg.querySelectorAll('.select').forEach(el => el.classList.remove('select'));

        // id と同じクラスを持つ要素に .select を追加
        const targetDiv = komaImg.querySelector(`.${targetId}`);
        if (targetDiv) {
          targetDiv.classList.add('select');

          // .ura と .omote の切り替え
          const uraBtn = document.querySelector('.ura');
          const omoteBtn = document.querySelector('.omote');
          if (uraBtn && omoteBtn) {
            uraBtn.classList.remove('on');
            omoteBtn.classList.add('on');
          }

          // 選択された .select 内の img を te1.png にする
          const img = targetDiv.querySelector('img');
          if (img) resetImageToFirst(img);
        }
          */
        handleSlideChange(targetId)
      }
    }
  });
});

/*
const playWrap = document.querySelector('.playWrap');
const modal = document.querySelector('.movieModal');
const inner = document.querySelector('.movieModal__inner');
const closeBtn = document.querySelector('.movieModal__close');
const youtubeBox = document.querySelector('.movieModal__youtube');

const youtubeId = '7dNfVbST2kE';

function openModal() {
  modal.classList.add('on');

  youtubeBox.innerHTML = `
    <iframe
      src="https://www.youtube.com/embed/${youtubeId}?autoplay=1&mute=1&rel=0&modestbranding=1&playsinline=1"
      title="YouTube video player"
      frameborder="0"
      allow="autoplay; encrypted-media; picture-in-picture"
      allowfullscreen>
    </iframe>
  `;
}

function closeModal() {
  modal.classList.remove('on');
}

playWrap.addEventListener('click', openModal);

// 背景クリックで閉じる
modal.addEventListener('click', closeModal);

// 動画エリアは閉じない
inner.addEventListener('click', (e) => {
  e.stopPropagation();
});

// ×ボタン
closeBtn.addEventListener('click', closeModal);

// フェードアウト完了後にYouTube停止
modal.addEventListener('transitionend', (e) => {
  if (e.propertyName !== 'opacity') return;

  if (!modal.classList.contains('on')) {
    youtubeBox.innerHTML = '';
  }
});
*/

const playWrap = document.querySelector('.playWrap');
const modal = document.querySelector('.movieModal');
const inner = document.querySelector('.movieModal__inner');
const closeBtn = document.querySelector('.movieModal__close');
const youtubeBox = document.querySelector('.movieModal__youtube');

const youtubeId = '7dNfVbST2kE';

// iPhone / iPad の判定（勝手にミュートされたときに戻す処理で使う）
const isIOS =
  /iPad|iPhone|iPod/.test(navigator.userAgent) ||
  (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

let player = null;
let playerReady = false;
let muteCheckTimer = null;

let wantSound = false;      // ユーザーが音ありを希望しているか
let expectedMuted = null;   // こちらが指示した状態（反映待ち）。null = 待ちなし

// プレーヤーの置き場所と、音あり／なし切り替えボタン
youtubeBox.innerHTML = `
  <div id="ytPlayer"></div>
  <button type="button" class="movieModal__sound" aria-label="音を出す">
    <!-- ミュート中のアイコン -->
    <svg class="movieModal__soundIcon movieModal__soundIcon--off" viewBox="0 0 24 24" aria-hidden="true">
      <path d="M4 9h4l5-4v14l-5-4H4z" fill="currentColor" />
      <path d="M16 9l5 6M21 9l-5 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" fill="none" />
    </svg>
    <!-- 音ありのアイコン -->
    <svg class="movieModal__soundIcon movieModal__soundIcon--on" viewBox="0 0 24 24" aria-hidden="true">
      <path d="M4 9h4l5-4v14l-5-4H4z" fill="currentColor" />
      <path d="M16 8.5a5 5 0 0 1 0 7M18.5 6a8.5 8.5 0 0 1 0 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" fill="none" />
    </svg>
  </button>
`;
const soundBtn = youtubeBox.querySelector('.movieModal__sound');

// YouTube IFrame Player API を読み込む
const tag = document.createElement('script');
tag.src = 'https://www.youtube.com/iframe_api';
document.head.appendChild(tag);

window.onYouTubeIframeAPIReady = () => {
  player = new YT.Player('ytPlayer', {
    videoId: youtubeId,
    playerVars: {
      rel: 0,
      playsinline: 1, // インラインで再生
      fs: 0           // 全画面ボタンを消す
    },
    events: {
      onReady: () => {
        playerReady = true;
        // API読み込み前に開かれていたらここで再生
        if (modal.classList.contains('on')) startMuted();
      }
    }
  });
};

// ボタンの見た目を状態に合わせる
function updateSoundBtn() {
  soundBtn.classList.toggle('is-on', wantSound);
  soundBtn.setAttribute('aria-label', wantSound ? '音を消す' : '音を出す');
}

// 音あり／なしを切り替える（音ありにするのはユーザーのタップの中で呼ぶこと）
function setSound(on) {
  wantSound = on;
  expectedMuted = !on;

  if (on) {
    player.unMute();
    player.setVolume(100);
    player.playVideo();
  } else {
    player.mute();
  }
  updateSoundBtn();
}

// プレーヤーの状態を監視する
function startWatch() {
  clearInterval(muteCheckTimer);
  muteCheckTimer = setInterval(() => {
    const muted = player.isMuted();

    // こちらの指示が反映されるまでは判定しない
    if (expectedMuted !== null) {
      if (muted === expectedMuted) expectedMuted = null;
      return;
    }

    // 希望どおりの状態なら何もしない
    if (muted === !wantSound) return;

    if (isIOS && wantSound && muted) {
      // iOSで、音ありのはずが勝手にミュートされた → 戻す
      console.log('勝手にミュート検知', player.getCurrentTime());
      expectedMuted = false;
      player.unMute();
      player.setVolume(100);
    } else {
      // YouTube側のボタンなどで切り替えられた → それに合わせる
      wantSound = !muted;
      updateSoundBtn();
    }
  }, 500);
}

// ミュートで再生開始
function startMuted() {
  wantSound = false;
  expectedMuted = true;
  player.mute();
  player.playVideo();
  updateSoundBtn();
  startWatch();
}

// 音あり／なし切り替えボタン（タップの中なのでiOSでも止まらない）
soundBtn.addEventListener('click', (e) => {
  e.stopPropagation();
  if (!playerReady) return;
  setSound(!wantSound);
});

function openModal() {
  modal.classList.add('on');
  if (playerReady) startMuted();
}

function closeModal() {
  modal.classList.remove('on');
  clearInterval(muteCheckTimer);
  if (playerReady) {
    player.pauseVideo();
    // 停止後にミュートを解除して、保存される状態を「音あり」にしておく
    player.unMute();
  }
}

playWrap.addEventListener('click', openModal);

// 背景クリックで閉じる
modal.addEventListener('click', closeModal);

// 動画エリアは閉じない
inner.addEventListener('click', (e) => {
  e.stopPropagation();
});

// ×ボタン
closeBtn.addEventListener('click', closeModal);

// フェードアウト完了後に先頭へ戻す
modal.addEventListener('transitionend', (e) => {
  if (e.propertyName !== 'opacity') return;

  if (!modal.classList.contains('on') && playerReady) {
    player.seekTo(0, true);
    player.pauseVideo();
  }
});